import {LICENSE_EXPIRES_NOTIFY_DAYS} from 'common/constants';
import {daysTo, isNotifiable} from 'common/dateUtils';
import {useToasts} from 'features/notifications/useToasts';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import {licenseSelectors} from 'redux/license';

export const useCheckLicenseExpiration = () => {
   const {t} = useTranslation();
   const expires = useSelector(licenseSelectors.expires);
   const {addToast} = useToasts();

   React.useEffect(() => {
      const daysLeft = daysTo(expires);
      // console.debug('license expire', daysLeft, expires);
      if (expires && isNotifiable(daysLeft, LICENSE_EXPIRES_NOTIFY_DAYS)) {
         addToast(t('Your Dipomat MFT license will expire in {{daysLeft}} days', {daysLeft}));
      }
   }, [expires, addToast]);
};
